import { render, staticRenderFns } from "./MonthAllowancesPlanDelete.vue?vue&type=template&id=7a391ae2&scoped=true&"
import script from "./MonthAllowancesPlanDelete.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a391ae2",
  null
  
)

export default component.exports